// Public-presentation flags. LUMEN CONTINUUM stays in the repo; it is simply not shown until its geometry is corrected.
// Glass/Glow cut-to-size cart stays in the repo; the Perception Audit is the public gateway.
export const FILM_CART_PUBLIC = process.env.REACT_APP_FILM_CART_PUBLIC === "true";
export const LUMEN_PUBLIC = process.env.REACT_APP_LUMEN_PUBLIC === "true";
